import React from 'react';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import update from 'immutability-helper';
import { T } from 'containers';
import { AppText } from 'domain/appText';
import styled from 'styled-components';

import Fuse from 'fuse.js';
import ImportModal from './importModal';
import './importFile.css';

// const PDFJS = require('pdfjs-dist');

const StyledButton = styled.button`
    background-color: transparent !important;
    color: white;
    border: 1px solid #4077ae;
    height: 49px;
    padding: 15px 15px 15px 45px;
    background-image: url(/assets/images/upload.png);
    background-repeat: no-repeat;
    background-size: 24px;
    background-position: 12px 50%;

    &:hover{
      background-color: #1a5c9e !important;
      border: 1px solid #4d81b4;
      cursor: pointer;
    }
  `;

class ImportFile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      formattedFile: [],
      checkedRows: [],
      showStenaTemplateDialog: false,
    };
  }

  onToggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  onDoneImportFileClick = (importedFileTitleRow) => {
    const {
      nationalities,
      ages,
      genders,
      importFileChangeGuest,
      saveRequest,
      guestIds,
      getImportedFileData,
      resetImportFile,
      stepBackAndForthInProcessImportedFile,
      personsLinkedToCabin,
      addAnonymousIdAndCabinForImport,
    } = this.props;
    const removTitleRowFromImportedFile = this.filterOutTitleRow(getImportedFileData);
    const getImportGuestsId = this.filterOutGuestsId(getImportedFileData);
    const getValueFromImportedFile = this.filterOutValueFromEachRow(removTitleRowFromImportedFile);
    const mapEngTitleToLocaleLang = this.mapTitleToindex(importedFileTitleRow);

    const indexOfNationalityFromLocaleLang = mapEngTitleToLocaleLang.indexOf('nationality');
    const indexOfAgeFromLocalLang = mapEngTitleToLocaleLang.indexOf('age');
    const indexOfGenderFromLocalLang = mapEngTitleToLocaleLang.indexOf('gender');

    if (indexOfNationalityFromLocaleLang > -1) {
      const getCorrectNationalityCode = getValueFromImportedFile.map(item => item[indexOfNationalityFromLocaleLang]).map(b => this.returnClosestMatch(b, nationalities));
      this.setCorrectItemInFile(getValueFromImportedFile, getCorrectNationalityCode, indexOfNationalityFromLocaleLang);
    }
    if (indexOfAgeFromLocalLang > -1) {
      const getCorrectAgesCode = getValueFromImportedFile.map(item => item[indexOfAgeFromLocalLang]).map(b => this.returnClosestMatch(b, ages));
      this.setCorrectItemInFile(getValueFromImportedFile, getCorrectAgesCode, indexOfAgeFromLocalLang);
    }
    if (indexOfGenderFromLocalLang > -1) {
      const getCorrectGendersCode = getValueFromImportedFile.map(item => item[indexOfGenderFromLocalLang]).map(b => this.returnClosestMatch(b, genders));
      this.setCorrectItemInFile(getValueFromImportedFile, getCorrectGendersCode, indexOfGenderFromLocalLang);
    }
    const mappedFileValueToCode = getValueFromImportedFile.map(importedFile => mapEngTitleToLocaleLang.map((title, index) => (title ? { value: importedFile[index], code: title } : null)).filter(a => a));
    const getAnonymousIds = guestIds.filter(g => g.includes('anonymous'));
    mappedFileValueToCode.forEach((item, i) => {
      const getGuestIdFromRowNumber = getAnonymousIds[i];
      item.forEach((obj) => {
        const { code, value } = obj;
        if (code === 'cabin') {
          const getCorrectCabin = this.returnCorrectCabin(personsLinkedToCabin, getImportGuestsId[i + 1]);
          if (getGuestIdFromRowNumber && getCorrectCabin.length > 0) {
            const object = { [getGuestIdFromRowNumber]: getCorrectCabin };
            addAnonymousIdAndCabinForImport(object);
            importFileChangeGuest(getGuestIdFromRowNumber, code, getCorrectCabin);
          }
        } else {
          importFileChangeGuest(getGuestIdFromRowNumber, code, value);
        }
      });
      if (i >= getValueFromImportedFile.length - 1) {
        this.onToggleModal();
        resetImportFile();
        stepBackAndForthInProcessImportedFile(0);
      }
      saveRequest(getGuestIdFromRowNumber, 'guests');
    });
  };

  onRemoveImportFileClick = () => {
    const { checkedRows } = this.state;
    const { updateImportedFile, resetImportFile, stepBackAndForthInProcessImportedFile, getImportedFileData } = this.props;
    if (checkedRows.length) {
      checkedRows.sort((a, b) => b - a).map(c => getImportedFileData.splice(c, 1));
      this.setState({ checkedRows: [] });
    }
    if (getImportedFileData.length <= 1) {
      resetImportFile();
      stepBackAndForthInProcessImportedFile(0);
    } else {
      updateImportedFile(getImportedFileData);
    }
  }

  onClickContinueWithImportNotStenaTemplate = () => {
    const { stepBackAndForthInProcessImportedFile, importedFileActiveStep } = this.props;
    this.setState({ showStenaTemplateDialog: false });
    stepBackAndForthInProcessImportedFile(importedFileActiveStep + 1);
  }

  onClickImportNewFileNotStenaTemplate = () => {
    const { resetImportFile } = this.props;
    this.setState({ showStenaTemplateDialog: false });
    resetImportFile();
  };

  /* eslint-disable no-param-reassign */
  setCorrectItemInFile = (file, listOfCode, indexFromLocaleLang) =>
  file.map((item, index) => {
    file[index][indexFromLocaleLang] = listOfCode[index];
    return file;
  });
  /* eslint-enable no-param-reassign */

  // getPDFPagedata = (pdf, num) => {
  //   const { setImportFile } = this.props;
  //   const self = this;
  //   let rowNumber = 0;
  //   let itemsProcessed = 0;
  //   const newState = [];
  //   pdf.getPage(num).then((page) => {
  //     page.getTextContent({ normalizeWhitespace: true }).then((textContent) => {
  //       let items = [];
  //       textContent.items.forEach((item, index) => {
  //         itemsProcessed += 1;
  //         // let highestNumberY = textContent.items[0].transform[5];
  //         const data = { value: item.str, transX: item.transform[4], transY: item.transform[5], page: num };
  //         if (self.ifOnNewRow(index, textContent, data)) {
  //           newState.push(items);
  //           rowNumber += 1;
  //           items = [];
  //         }
  //         if (newState.length === 0 && rowNumber === 0 && num === 1) {
  //           // highestNumberY = data.transY;
  //           data.titleRow = true;
  //         }
  //         data.rowNumber = rowNumber;
  //         items.id = this.makeid();
  //         data.id = this.makeid();
  //         items.push(data);
  //         if (itemsProcessed >= textContent.items.length) {
  //           newState.id = this.makeid();
  //           newState.push(items);
  //           const newFormattedFile = this.state.formattedFile;
  //           newFormattedFile.push(...newState);
  //           const sortedFile = newFormattedFile.sort(this.comparePage);
  //           self.setState({ formattedFile: sortedFile, checkedRows: [] });
  //           setImportFile(sortedFile);
  //         }
  //       });
  //     });
  //   });
  // };

  // comparePage = (a, b) => {
  //   if (a[1].page < b[1].page) return -1;
  //   if (a[1].page > b[1].page) return 1;
  //   if (a[1].rowNumber < b[1].rowNumber) return -1;
  //   if (a[1].rowNumber > b[1].rowNumber) return 1;
  //   return 0;
  // }

  // mapTitleToindex = (appTexts, file) => file.map(title => title ? appTexts.filter(correspondingTitle => Object.values(correspondingTitle)[0] === title)
  //   .map(t => Object.keys(t)[0]) : null)
  //   .map(title => title ? title[0].charAt(0).toLowerCase() + title[0].substr(1) : null);

  // readPdf = (files) => {
  //   const file = files[0];
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     this.setState({ formattedFile: [], checkedRows: [] });
  //     const data = reader.result;
  //     PDFJS.getDocument(data).then((pdf) => {
  //       for (let num = 1; num <= pdf.numPages; num += 1) {
  //         this.getPDFPagedata(pdf, num);
  //       }
  //     });
  //   };
  // };

  // isFormattedPDFAdded = index => !!this.state.formattedFile[index];

  // isOnTitleRow = (highestNumberY, data) => {
  //   if (highestNumberY <= data.transY) {
  //     return true;
  //   }
  //   return false;
  // }

  // ifOnNewRow = (index, textContent, data) => {
  //   if (index > 0 && (textContent.items[index - 1].transform[5] !== data.transY)) {
  //     return true;
  //   }
  //   return false;
  // }

  // getClosestXTitleValueInPDF = (arr, num) => {
  //   if (arr.length) {
  //     const titleArr = arr[0].filter(a => a.titleRow);
  //     let curr = titleArr[0].transX;
  //     let diff = Math.abs(num - curr);
  //     for (let i = 0; i < titleArr.length; i += 1) {
  //       const newdiff = Math.abs(num - titleArr[i].transX);
  //       if (newdiff <= diff) {
  //         diff = newdiff;
  //         curr = titleArr[i].value;
  //       }
  //     }
  //     return curr;
  //   }
  //   return false;
  // }

  setCorrectColumnToCorrectTitle = (index, title) => {
    const { setCorrectColumnFromImportedFile } = this.props;
    setCorrectColumnFromImportedFile(index, title);
  };

  removeCorrectColumnToCorrectTitle = (column) => {
    const { removeCorrectColumnFromImportedFile } = this.props;
    removeCorrectColumnFromImportedFile(column);
  }

  filterOutValueFromEachRow = fileWithoutTitleRow => fileWithoutTitleRow.map(item => item.map(data => data.value));

  filterOutTitleRow = file => file.map(item => item.filter(data => !data.titleRow)).filter(arr => arr.length);

  filterOutGuestsId = file => file.map(item => item.id).filter(arr => arr.length);

  returnCorrectCabin = (personsLinkedToCabin, guestId) => {
    const cabinId = personsLinkedToCabin && personsLinkedToCabin.map(linked => linked.guests.id.map(id => id === guestId ? linked.cabin : null).filter(a => a)).filter(a => a.length);
    return cabinId;
  }

  mapTitleToindex = titleRow => titleRow.map(title => title && title.name);

  returnArrayLowerCase = array => array.map((obj) => {
    obj.text.toLowerCase();
    return obj;
  });

  returnClosestMatch = (string, array) => {
    const keysToFind = ['code', 'text'];
    const lowerCaseArray = this.returnArrayLowerCase(array);
    const stringToLowerCase = string.toLowerCase();
    const options = {
      shouldSort: true,
      threshold: 0.8,
      distance: 1,
      findAllMatches: true,
      keys: keysToFind,
    };
    let fuse = new Fuse(lowerCaseArray, options);
    let res = fuse.search(stringToLowerCase);
    while (res.length !== 1 && res.length > 0) {
      options.threshold -= 0.01;
      options.distance += 1;
      fuse = new Fuse(res, options);
      const res1 = fuse.search(stringToLowerCase);
      res = res1;
    }
    if (res.length === 1) {
      return res[0].code;
    }
    return null;
  }

  handleImportedFile = (file, appTexts) => {
    // const PDF = file[0] && file[0].type.includes('pdf');
    // if (PDF) {
    //   this.readPdf(file);
    // }

    const EXCEL = file[0] && file[0].type.includes('sheet');
    if (EXCEL) {
      this.readExcel(file, appTexts);
    }
    document.getElementById('file-upload').value = '';
  };

  readExcel = (files, appTexts) => {
    const reader = new FileReader();
    const file = files[0];

    if (reader.readAsBinaryString) {
      reader.readAsBinaryString(file);
      reader.onload = (e) => {
        const data = e.target.result;
        return this.readXLSX(data, appTexts);
      };
    } else {
      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        const bytes = new Uint8Array(e.target.result);
        const binary = bytes.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
        this.readXLSX(binary, appTexts);
      };
    }
    reader.onerror = () => {
      // console.error(ex);
    };
  };

  readXLSX = (data, appTexts) => {
    const { stepBackAndForthInProcessImportedFile, importedFileActiveStep, setImportFile } = this.props;

    const workbook = XLSX.read(data, {
      type: 'binary',
      dateNF: 'dd/mm/yyyy',
    });
    const company = workbook.Props.Company;
    const author = workbook.Props.Author;
    const isStenaTemplate = (company && company.includes('Stena')) || (author && author.includes('Stena'));
    let titleRow = [];
    workbook.SheetNames.forEach((sheetName) => {
      const rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
      if (rowObject.length) {
        titleRow = rowObject && Object.keys(rowObject[0]).map((row) => {
          const getSpecificApptext = appTexts && appTexts.filter(text => (
            Object.keys(text).toString().toLowerCase() === row.replace(/ +/g, '').toLowerCase()
            ||
            Object.values(text).toString().toLowerCase() === row.replace(/ +/g, '').toLowerCase()
          ));
          const getApptext = getSpecificApptext.map(t => Object.values(t)).toString();
          const getAppname = getSpecificApptext.map(t => Object.keys(t)).toString();
          const object = { name: getAppname || null, text: getApptext || null, titleRow: true, id: this.makeid() };
          return object;
        });
      } else {
        return null;
      }
      const result = rowObject && rowObject.map(row => Object.values(row).map(item => ({ value: item, id: this.makeid() })));
      result.unshift(titleRow);
      const resultWithId = [];
      result.map((obj) => {
        const o = obj;
        o.id = this.makeid();
        return resultWithId.push(o);
      });
      let newState = null;
      newState = update(this.state, {
        formattedFile: { $set: result },
        stenaTemplate: { $set: isStenaTemplate },
      });
      if (isStenaTemplate) {
        stepBackAndForthInProcessImportedFile(importedFileActiveStep + 1);
      } else {
        this.setState({ showStenaTemplateDialog: true });
      }
      newState.formattedFile.id = this.makeid();
      setImportFile(newState);
      return null;
    });
  }

  makeid = () => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 10; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  importedFileHasMoreRowsThanGuests = () => {
    const { getImportedFileData } = this.props;
    const { guestIds } = this.props;
    const formattedFileLength = getImportedFileData.length ? getImportedFileData.length - 1 : null;
    const getAnonymousIds = guestIds.filter(g => g && g.includes('anonymous'));
    if (getAnonymousIds.length && formattedFileLength && formattedFileLength > getAnonymousIds.length) {
      return { newGuests: formattedFileLength, anonymous: getAnonymousIds.length };
    }
    return {};
  }

  rowIsActive = (index) => {
    const { checkedRows } = this.state;
    if (checkedRows.includes(index)) {
      const newCheckedRows = checkedRows.filter(c => c !== index);
      this.setState({ checkedRows: newCheckedRows });
    } else {
      this.setState({ checkedRows: [...this.state.checkedRows, index] });
    }
  }

  // showSpinner = () => <div className="save-status-spinner-container"><Spinner className="save-status-spinner" size={5} /></div>;

  render() {
    const { showModal, checkedRows, showStenaTemplateDialog } = this.state;
    const {
      reservationCode,
      importedFileTitleRow,
      cabinsAllocated,
      titleOnColumnNumber,
      mandatoryBirthdate,
      cabindIds,
      guestIds,
      setImportFile,
      updateImportedFile,
      importStepProcess,
      importedFileActiveStep,
      stepBackAndForthInProcessImportedFile,
      cabinData,
      setActiveCabinForImportedFileCabinDistributor,
      setActivePersonForImportedFileCabinDistributor,
      setActiveCabinClusterForImportedFile,
      activeCabinInCabinDistributor,
      activePersonInCabinDistributor,
      personsLinkedToCabin,
      getImportedFileData,
      cabinsOut,
      cabinsHome,
      removePersonFromPersonsLinkedToCabinImportedFile,
      isBirthDateMandatory,
      allRemainingCabinsIdsWithoutGuests,
      routeNameOut,
      routeNameHome,
      getRemainingBeds,
    } = this.props;
    const getAnonymousIds = guestIds.filter(g => g && g.includes('anonymous'));
    return (
      <T
        text={[
          AppText.Age,
          AppText.Cabin,
          AppText.DateOfBirth,
          AppText.FirstName,
          AppText.Gender,
          AppText.LastName,
          AppText.Nationality,
          AppText.ImportFileBackButton,
          AppText.ImportFileChooseColumnPlaceholder,
          AppText.ImportFileDoneGuestsText,
          AppText.ImportFileDoneGuestToImportText,
          AppText.ImportFileDoneCabinOutText,
          AppText.ImportFileDoneCabinHomeText,
          AppText.ImportFileDoneGuestTotalText,
          AppText.ImportFileDoneButton,
          AppText.ImportFileNextButton,
          AppText.ImportFileRemoveButton,
          AppText.ImportFileUploadButton,
          AppText.ImportFileUploadFileExplanationText,
          AppText.ImportFileUploadFileTitle,
          AppText.ImportFileShowModalButton,
          AppText.ImportFileStepProcessChooseColumnText,
          AppText.ImportFileStepProcessUploadFileText,
          AppText.ImportFileStepProcessRemoveRowsText,
          AppText.ImportFileStepProcessCabinText,
          AppText.ImportFileStepProcessCompleteText,
          AppText.ImportFileUploadCompleteTitle,
          AppText.ImportFileUploadCompleteExplanationText,
          AppText.ImportFileRightClickMenuPaste,
          AppText.ImportFileCopyPasteTitle,
          AppText.ImportFileCopyPasteExplanation,
          AppText.ImportFileCopyPastePlaceholder,
          AppText.ImportFileHeaderTitle,
          AppText.ImportFileChooseColumnTitle,
          AppText.ImportFileChooseColumnExplanation,
          AppText.ImportFileRemoveDataTitle,
          AppText.ImportFileRemoveDataExplanation,
          AppText.ImportFileRemoveDataTextRemoveRow,
          AppText.ImportFileDoneImportText,
          AppText.ImportFileNotStenaTemplateTitle,
          AppText.ImportFileNotStenaTemplateExplanation,
          AppText.ImportFileNotStenaTemplateUploadNewFileTitle,
          AppText.ImportFileNotStenaTemplateContinueText,
          AppText.ImportFileDownloadTemplateTitle,
          AppText.ImportFileMoreRowsThanGuestsTitle,
          AppText.ImportFileMoreRowsThanGuestsInImportedFile,
          AppText.ImportFileMoreRowsThanGuestsInReservation,
          AppText.CabinInstructionList,
          AppText.CabinsAllocatedInfo,
          AppText.SelectCabinInfoCompleteDescription,
          AppText.SelectCabinInfoEmptyDescription,
          AppText.SelectCabinInfoErrorDescription,
          AppText.SelectCabinInfoHeading,
          AppText.SelectCabinInfoParagraph,
          AppText.SelectCabinInfoSelectCabin,
          AppText.SelectCabinInfoStartedDescription,
          AppText.FilterTabAvailableCabins,
          AppText.FilterTabFullCabins,
          AppText.CabinDistributionDone,
        ]}
        render={([
          age,
          cabin,
          dateOfBirth,
          firstName,
          gender,
          lastName,
          nationality,
          importFileBackButton,
          importFileChooseColumnPlaceholder,
          importFileDoneGuestsText,
          importFileDoneGuestToImportText,
          importFileDoneCabinOutText,
          importFileDoneCabinHomeText,
          importFileDoneGuestTotalText,
          importFileDoneButton,
          importFileNextButton,
          importFileRemoveButton,
          importFileUploadButton,
          importFileUploadFileExplanationText,
          importFileUploadFileTitle,
          importFileShowModalButton,
          importFileStepProcessUploadFileText,
          importFileStepProcessChooseColumnText,
          importFileStepProcessRemoveRowsText,
          importFileStepProcessCabinText,
          importFileStepProcessCompleteText,
          importFileUploadCompleteTitle,
          importFileUploadCompleteExplanationText,
          importFileRightClickMenuPaste,
          importFileCopyPasteTitle,
          importFileCopyPasteExplanation,
          importFileCopyPastePlaceholder,
          importFileHeaderTitle,
          importFileChooseColumnTitle,
          importFileChooseColumnExplanation,
          importFileRemoveDataTitle,
          importFileRemoveDataExplanation,
          importFileRemoveDataTextRemoveRow,
          importFileDoneImportText,
          importFileNotStenaTemplateTitle,
          importFileNotStenaTemplateExplanation,
          importFileNotStenaTemplateUploadNewFileTitle,
          importFileNotStenaTemplateContinueText,
          importFileDownloadTemplateTitle,
          importFileMoreRowsThanGuestsTitle,
          importFileMoreRowsThanGuestsInImportedFile,
          importFileMoreRowsThanGuestsInReservation,
          cabinInstructionList,
          cabinsAllocatedInfo,
          selectCabinInfoCompleteDescription,
          selectCabinInfoEmptyDescription,
          selectCabinInfoErrorDescription,
          selectCabinInfoHeading,
          selectCabinInfoParagraph,
          selectCabinInfoSelectCabin,
          selectCabinInfoStartedDescription,
          filterTabAvailableCabins,
          filterTabFullCabins,
          cabinDistributionDone,
        ]) => (
          <div className="import-file-outer">
            {cabinsAllocated || getAnonymousIds.length === 0 ? null : <StyledButton onClick={() => this.onToggleModal()}>{importFileShowModalButton}</StyledButton>}
            { showModal ?
              <ImportModal
                reservationCode={reservationCode}
                makeid={this.makeid}
                setCorrectColumnToCorrectTitle={this.setCorrectColumnToCorrectTitle}
                removeCorrectColumnToCorrectTitle={this.removeCorrectColumnToCorrectTitle}
                onToggleModal={this.onToggleModal}
                handleImportedFile={this.handleImportedFile}
                formattedFile={getImportedFileData}
                importedFileTitleRow={importedFileTitleRow}
                titleOnColumnNumber={titleOnColumnNumber}
                mandatoryBirthdate={mandatoryBirthdate}
                onDoneImportFileClick={() => this.onDoneImportFileClick(titleOnColumnNumber)}
                onRemoveImportFileClick={this.onRemoveImportFileClick}
                importedFileHasMoreRowsThanGuests={this.importedFileHasMoreRowsThanGuests()}
                cabindIds={cabindIds}
                appTexts={[{ firstName }, { lastName }, { dateOfBirth }, { gender }, { age }, { nationality }, { cabin }]}
                appTextsForImportFile={{
                  doneButton: importFileDoneButton,
                  chooseColumnPlaceholder: importFileChooseColumnPlaceholder,
                  uploadButton: importFileUploadButton,
                  removeButton: importFileRemoveButton,
                  nextButton: importFileNextButton,
                  backButton: importFileBackButton,
                  uploadFileExplanationText: importFileUploadFileExplanationText,
                  uploadFileTitle: importFileUploadFileTitle,
                  stepProcessUploadFileText: importFileStepProcessUploadFileText,
                  stepProcessChooseColumnText: importFileStepProcessChooseColumnText,
                  stepProcessRemoveRowsText: importFileStepProcessRemoveRowsText,
                  stepProcessCabinText: importFileStepProcessCabinText,
                  stepProcessCompleteText: importFileStepProcessCompleteText,
                  uploadCompleteTitle: importFileUploadCompleteTitle,
                  uploadCompleteExplanationText: importFileUploadCompleteExplanationText,
                  rightClickMenuPaste: importFileRightClickMenuPaste,
                  copyPasteTitle: importFileCopyPasteTitle,
                  copyPasteExplanation: importFileCopyPasteExplanation,
                  copyPastePlaceholder: importFileCopyPastePlaceholder,
                  headerTitle: importFileHeaderTitle,
                  chooseColumnTitle: importFileChooseColumnTitle,
                  chooseColumnExplanation: importFileChooseColumnExplanation,
                  removeDataTitle: importFileRemoveDataTitle,
                  removeDataExplanation: importFileRemoveDataExplanation,
                  removeDataTextRemoveRow: importFileRemoveDataTextRemoveRow,
                  doneImportText: importFileDoneImportText,
                  notStenaTemplateTitle: importFileNotStenaTemplateTitle,
                  notStenaTemplateExplanation: importFileNotStenaTemplateExplanation,
                  notStenaTemplateUploadNewFileTitle: importFileNotStenaTemplateUploadNewFileTitle,
                  notStenaTemplateContinueText: importFileNotStenaTemplateContinueText,
                  downloadTemplateTitle: importFileDownloadTemplateTitle,
                  moreRowsThanGuestsTitle: importFileMoreRowsThanGuestsTitle,
                  moreRowsThanGuestsInImportedFile: importFileMoreRowsThanGuestsInImportedFile,
                  moreRowsThanGuestsInReservation: importFileMoreRowsThanGuestsInReservation,
                  cabinInstructionList,
                  cabinsAllocatedInfo,
                  selectCabinInfoCompleteDescription,
                  selectCabinInfoEmptyDescription,
                  selectCabinInfoErrorDescription,
                  selectCabinInfoHeading,
                  selectCabinInfoParagraph,
                  selectCabinInfoSelectCabin,
                  selectCabinInfoStartedDescription,
                  filterTabAvailableCabins,
                  filterTabFullCabins,
                  cabinDistributionDone,
                  importFileDoneGuestsText,
                  importFileDoneGuestToImportText,
                  importFileDoneCabinOutText,
                  importFileDoneGuestTotalText,
                  importFileDoneCabinHomeText,
                }}
                setImportFile={setImportFile}
                updateImportedFile={updateImportedFile}
                rowIsActive={this.rowIsActive}
                checkedRows={checkedRows}
                importStepProcess={importStepProcess}
                importedFileActiveStep={importedFileActiveStep}
                stepBackAndForthInProcessImportedFile={stepBackAndForthInProcessImportedFile}
                cabinData={cabinData}
                setActiveCabinForImportedFileCabinDistributor={setActiveCabinForImportedFileCabinDistributor}
                setActivePersonForImportedFileCabinDistributor={setActivePersonForImportedFileCabinDistributor}
                setActiveCabinClusterForImportedFile={setActiveCabinClusterForImportedFile}
                activeCabinInCabinDistributor={activeCabinInCabinDistributor}
                activePersonInCabinDistributor={activePersonInCabinDistributor}
                personsLinkedToCabin={personsLinkedToCabin}
                getImportedFileData={getImportedFileData}
                cabinsOut={cabinsOut}
                cabinsHome={cabinsHome}
                showStenaTemplateDialog={showStenaTemplateDialog}
                onClickContinueWithImportNotStenaTemplate={this.onClickContinueWithImportNotStenaTemplate}
                onClickImportNewFileNotStenaTemplate={this.onClickImportNewFileNotStenaTemplate}
                removePersonFromPersonsLinkedToCabinImportedFile={removePersonFromPersonsLinkedToCabinImportedFile}
                isBirthDateMandatory={isBirthDateMandatory}
                allRemainingCabinsIdsWithoutGuests={allRemainingCabinsIdsWithoutGuests}
                routeNameOut={routeNameOut}
                routeNameHome={routeNameHome}
                getRemainingBeds={getRemainingBeds}
              />
              : null}
          </div>
        )}
      />
    );
  }
}

ImportFile.propTypes = {
  reservationCode: PropTypes.string,
  setImportFile: PropTypes.func,
  updateImportedFile: PropTypes.func,
  resetImportFile: PropTypes.func,
  importFileChangeGuest: PropTypes.func,
  saveRequest: PropTypes.func,
  setCorrectColumnFromImportedFile: PropTypes.func,
  cabinsAllocated: PropTypes.bool,
  removeCorrectColumnFromImportedFile: PropTypes.func,
  stepBackAndForthInProcessImportedFile: PropTypes.func,
  nationalities: PropTypes.array,
  ages: PropTypes.array,
  genders: PropTypes.array,
  importedFileTitleRow: PropTypes.array,
  guestIds: PropTypes.array,
  titleOnColumnNumber: PropTypes.array,
  mandatoryBirthdate: PropTypes.bool,
  cabindIds: PropTypes.array,
  importStepProcess: PropTypes.array,
  importedFileActiveStep: PropTypes.number,
  cabinData: PropTypes.array,
  setActiveCabinForImportedFileCabinDistributor: PropTypes.func,
  setActivePersonForImportedFileCabinDistributor: PropTypes.func,
  setActiveCabinClusterForImportedFile: PropTypes.func,
  activeCabinInCabinDistributor: PropTypes.string,
  activePersonInCabinDistributor: PropTypes.string,
  personsLinkedToCabin: PropTypes.array,
  getImportedFileData: PropTypes.array,
  cabinsOut: PropTypes.array,
  cabinsHome: PropTypes.array,
  removePersonFromPersonsLinkedToCabinImportedFile: PropTypes.func,
  addAnonymousIdAndCabinForImport: PropTypes.func,
  isBirthDateMandatory: PropTypes.bool,
  allRemainingCabinsIdsWithoutGuests: PropTypes.array,
  routeNameOut: PropTypes.string,
  routeNameHome: PropTypes.string,
  getRemainingBeds: PropTypes.number,
};

export default ImportFile;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/index.js